module.exports = __webpack_public_path__ + "img/development_bg.889427e6.jpg";